<script>
	/**
	 * @typedef {Object} Author
	 * @property {string} [first_name] - The first name of the author.
	 * @property {string} [middle_name] - The middle name of the author.
	 * @property {string} [last_name] - The last name of the author.
	 * @property {string} [orcid] - The ORCID of the author.
	 */
	/** @type {Array<Author>} **/
	export let authors = [];
	const ORCID_URL = 'https://orcid.org/';
</script>

<div class="flex flex-wrap items-center py-6 space-x-3" role="list">
	{#each authors as author, index (author)}
		<span
			class="flex items-center text-xl whitespace-nowrap"
			role="listitem"
			vocab="https://schema.org/"
			typeof="Person"
		>
			<a
				class="text-gray-600 cursor-pointer hover:underline"
				href={`#author-info-${index + 1}`}
				property="url"
			>
				<span property="givenName">{author.first_name || ''}</span>
				<span property="additionalName">{author.middle_name ? ` ${author.middle_name}` : ''}</span>
				<span property="familyName">{author.last_name ? ` ${author.last_name}` : ''}</span>
			</a>
			{#if author.orcid}
				<a
					href={`${ORCID_URL}${author.orcid}`}
					target="_blank"
					rel="noopener noreferrer"
					property="sameAs"
					class="ml-1"
				>
					<img
						class="inline-block w-4 h-4"
						src="/images/icons/orcid.svg"
						alt="ORCID of ${author.first_name || ''} ${author.last_name || ''}"
					/>
				</a>
			{/if}
			{#if index < authors.length - 1}
				<span class="mx-1">,</span>
			{/if}
		</span>
	{/each}
</div>
